import i18n from 'modules/core/lib/i18n'

import { ExportFormat } from './format'

export const getDescriptionForFormat = (format: ExportFormat): string | undefined => {
  switch (format) {
    case ExportFormat.CONTRACT_CHANGES:
      return i18n.t('payroll_bundle.export.descriptions.contract_changes')
    case ExportFormat.SILAE_LEAVES:
      return i18n.t('payroll_bundle.export.silae_codes_description')
  }
}
